// extracted by mini-css-extract-plugin
export var actionText = "_rx-4";
export var container = "_rx-0";
export var leftSection = "_rx-1";
export var rightSection = "_rx-2";
export var settingsButton = "_rx-6";
export var settingsIcon = "_rx-7";
export var shortcut = "_rx-5";
export var shortcutGroup = "_rx-3";